export class EntidadDto{
    public idEntidad!:number;
    public idTipoEntidad!:number;
}